module.exports = __webpack_public_path__ + "img/ny_page_img1.38eff29a.png";